//// we create a site.ts file to mimic a brand site setup. All this does is import the entire DS Core library, but it let us build with the same setup
import "reflect-metadata";
import { Startup } from "./startup";
import { getContainer } from "./dscontainer";
import { getEnvironment } from "./environments/environmentProvider";
import { Environment } from "./environments/environment";

// load the environment settings, then create the inversify container then start the site
getEnvironment<Environment>().then(environment => {
		const container = getContainer(environment);
		const startup = container.get(Startup);
		startup.start();
});